import React, { useState } from "react";
import search_icon from "../../../assets/svg/zoom-in.svg";

const Search = ({ onSearch, placeholder }) => {
  const [search, setSearch] = useState("");

  const onInputChange = (value) => {
    setSearch(value);
    onSearch(value);
  };

  return (
    <div className="input-group">
      <input
        type="text"
        className="form-control"
        placeholder={placeholder}
        style={{ width: "205px" }}
        value={search}
        onChange={(e) => onInputChange(e.target.value)}
      />
      <span className="input-group-text sb-icon-wrp" id="basic-addon2">
        <img src={search_icon} alt="search icon" />
      </span>
    </div>
  );
};

export default Search;
